import {includes} from 'ramda';

import {DashboardTileId} from '../types/DashboardTileId';
import {DASHBOARD_TILE_IDS} from './dashboardTileIds';

export function isDashboardTileId(value: string): value is DashboardTileId {
  return includes(value, DASHBOARD_TILE_IDS);
}
